<template>
    <b-modal :active.sync="showSignUpModal"
    		has-modal-card
        	trap-focus
            aria-role="dialog"
            aria-modal
            scroll="keep">
		<form action="">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">Sign Up</p>
                </header>
                <div v-if="form === 'new_user'">
                    <section class="modal-card-body">

                        <b-field label="Name">
                            <b-input
                                v-model="name"
                                placeholder="Your name"
                                required>
                            </b-input>
                        </b-field>

                        <b-field label="Email">
                            <b-input
                                v-model="email"
                                placeholder="Your email"
                                required>
                            </b-input>
                        </b-field>

                        <b-field label="Organization">
                            <b-input
                                v-model="organization"
                                placeholder="Your organization"
                                required>
                            </b-input>
                        </b-field>

                        <b-field label="Password">
                            <b-input
                                type="password"
                                v-model="password"
                                password-reveal
                                placeholder="Your password"
                                required>
                            </b-input>
                        </b-field>
                        
                        <p class="text-center">
                            <a @click="verificationForm">
                                Already got a confirmation code?
                            </a>
                        </p>
                    </section>
                </div>
                <div v-else-if="form === 'verification'">
                    <section class="modal-card-body">
                        <b-field label="Email">
                            <b-input
                                v-model="email"
                                type="email"
                                placeholder="Your email"
                                required>
                            </b-input>
                        </b-field>

                        <b-field label="Confirmation code">
                            <b-field grouped>
                                <b-input
                                    v-model="code"
                                    placeholder="Your code"
                                    required>
                                </b-input>
                                <p class="control">
                                    <b-button class="button is-light" @click="resendConfirmation">
                                        Resend
                                    </b-button>
                                </p>
                            </b-field>
                        </b-field>
                    </section>
                </div>
                <footer class="modal-card-foot">
                    <div v-if="form === 'new_user'">
                        <button class="button is-primary is-fullwidth" type="button" @click="signUpNewUser">Sign Up</button>
                        <p class="text-center">
                            <small>By providing your emailadress, you agree to our<br><a href="https://www.maptm.nl/wp-content/uploads/2020/02/MAPtm-privacyverklaring.pdf">Privacy Policy</a></small>
                        </p>
                    </div>
                    <button v-if="form === 'verification'" class="button is-primary is-fullwidth" type="button" @click="confirmNewUser">Confirm</button>
                </footer>
            </div>
        </form>
	</b-modal>
</template>


<script>
    import { Auth } from 'aws-amplify'
	export default {
		name: 'SignUpModal',

        computed: {
            showSignUpModal: {
                get() {
                    return this.$store.getters.showSignUpModal
                },
                set() {
                    this.$store.commit('toggleSignUpModal')
                    this.form = 'new_user'
                }
            },
        },

        methods: {
            signUpNewUser () {
                Auth.signUp({
                    username: this.email,
                    password: this.password,
                    attributes: {
                        email: this.email,
                        name: this.name,
                        'custom:organization': this.organization
                    }
                })
                .then(data => {
                    this.$buefy.dialog.alert('An email with a confirmation code has been sent to ' + this.email)
                    this.form = 'verification'
                })
                .catch(err => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: err.message,
                        type: 'is-danger',
                        hasIcon: true
                    })
                })
            },

            resendConfirmation () {
                Auth.resendSignUp(this.email)
                .then(data => {
                    this.$buefy.dialog.alert('An email with a confirmation code has been sent to ' + this.email)
                })
                .catch(err => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: err.message,
                        type: 'is-danger',
                        hasIcon: true
                    })
                })
            },

            confirmNewUser () {
                Auth.confirmSignUp(this.email, this.code)
                .then(data => {
                    this.$buefy.dialog.alert('Your account has been confirmed')
                    this.$store.commit('toggleSignUpModal')
                    this.$store.commit('toggleLoginModal')
                    this.form = 'new_user'
                })
                .catch(err => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: err.message,
                        type: 'is-danger',
                        hasIcon: true
                    })
                })
            },

            verificationForm () {
                this.form = 'verification'
            },

            newUserForm () {
                this.form = 'new_user'
            }
        },

		data() {
			return {
                password: null,
                name: null,
				email: null,
                organization: null,
                form: 'new_user',
                code: null
			}
		}
	}
</script>

<style>
    .text-center {
        text-align: center;
    }
</style>